import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "NewsletterFooterModule",
    component: () =>
        __SERVER__ ? require("./newsletter-footer-module-view") : import("./newsletter-footer-module-view")
});

export default definition;
